
(function(){
  var frames = [
    { src: "https://cdn.shopify.com/s/files/1/1081/2414/3947/files/charms_4_carre.png?v=1789476742", label: "Les 4 variantes" },
    { src: "https://cdn.shopify.com/s/files/1/1081/2414/3947/files/charm_saumon_final.png?v=1789545707", label: "Saumon" },
    { src: "https://cdn.shopify.com/s/files/1/1081/2414/3947/files/charm_onyx_final.png?v=1789545706", label: "Onyx" },
    { src: "https://cdn.shopify.com/s/files/1/1081/2414/3947/files/charm_ocean_final.png?v=1789545699", label: "Océan" },
    { src: "https://cdn.shopify.com/s/files/1/1081/2414/3947/files/charm_soleil_final.png?v=1789545695", label: "Soleil" }
  ];

  document.querySelectorAll('.angle-viewer').forEach(function(viewer){
    var idx = 0;
    var img = viewer.querySelector('.angle-img');
    var label = viewer.querySelector('.angle-label');
    var dots = viewer.querySelectorAll('.angle-dots button');
    var stage = viewer.querySelector('.angle-stage');
    if (!img || !stage) return;

    function render() {
      img.src = frames[idx].src;
      if (label) label.textContent = frames[idx].label;
      dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
    }
    function go(delta) {
      idx = (idx + delta + frames.length) % frames.length;
      render();
    }

    var prevBtn = stage.querySelector('.prev');
    var nextBtn = stage.querySelector('.next');
    if (prevBtn) prevBtn.addEventListener('click', function(){ go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ go(1); });
    dots.forEach(function(d){
      d.addEventListener('click', function(){ idx = parseInt(d.dataset.i,10); render(); });
    });
  });
})();


  var navEl = document.querySelector('.nav');
  function updateNav() {
    if (!navEl) return;
    if (window.scrollY > window.innerHeight * 0.55) {
      navEl.classList.add('scrolled');
    } else {
      navEl.classList.remove('scrolled');
    }
  }
  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();
